<!--首页-->
<template>
	 
		<div class="box">
			<div class="top-box">
				<div class="title">2020年全国啦啦操公开赛</div>
			 	  <van-dropdown-menu>
					<van-dropdown-item v-model="value"  >
						<template #title> 
							<p class="dropdown-item-title">{{option[value].text}}</p> 
						</template>
						<div v-for="(item,i) in option" :key="i" class="dropdown-item" @click="dropdownChange(item)">
							<p class="dropdown-item-option-title">{{item.text}}</p> 
						</div>
					</van-dropdown-item>
				</van-dropdown-menu>
			</div>

			<div class="activity-list" v-for="i in 2" :key="i">
				<div class="activity-list-title-box">
					<div class="title-left-solid"></div>
					<div class="activity-title">公开幼儿乙组-舞蹈啦啦操-集体花球自选动作</div>
				</div>
				<div class="list-team">
					<div class="team-item" v-for="(item,i) in 5" :key="i">
						<div class="team-rank">
							<div :class="'team-rank-num rank-change'+i" v-if="i<3">{{i+1}}.</div>
							<div class="team-rank-num rank-no" v-else>{{i+1}}</div>

						</div>
						<div class="team-info">
							<div class="team-info-name">广州华怡教育小麒麟啦啦队</div>
							<div class="team-info-grande">决赛 182分  预赛150分</div>
						</div>
					</div>

					<div></div>
				</div>
			</div>
			 
 
		</div>

 
</template>
<style scoped>
	/* @import '../../assets/style/index.css'; */
	.dropdown-item-option-title{
		height: 30px;
		line-height: 30px;
		margin-top: 5px;
		text-align: center;
		border-bottom: 1px solid #efefef;
	}
	.rank-change0{
		color: #F5A623;
		font-size:20px;
	}
	.rank-change1{
		color: #9B9B9B;
		font-size:20px;
	}
	.rank-change2{
		color: #D0021B;
		font-size:20px;
	}
	.rank-no{
		font-size: 16px;
		color: #333333;
	}
	.team-rank-num{
		height:20px;
		width: 20px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		line-height:20px;
		text-align: right;
		margin-right: 10px;
	}
	.team-info-grande{
		height:17px;
		font-size:12px;
		font-family:PingFangSC-Regular,PingFang SC;
		font-weight:400;
		color:rgba(102,102,102,0.85);
		line-height:17px;
	}
	.team-info-name{
	height:20px;
	font-size:14px;
	font-family:PingFangSC-Regular,PingFang SC;
	font-weight:400;
	color:rgba(0,0,0,0.85);
	line-height:20px;
	}
	.team-item{width: 100%;display: flex;margin: 20px 0;}
	.list-team{
		width: 90%;		
		margin: 0 auto;
	}
	.activity-title{
		height:20px;font-size:14px;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;color:rgba(0,0,0,0.85);line-height:20px;
	}
	.activity-list{
		width: 6.9rem;padding: 5px;margin: 0 auto;margin-top: 13px;border-radius: 10px;background: #fff;
	}
	.title-left-solid{
		width:4px;height:15px;background:rgba(208,2,27,1);border-radius:2px;margin: 0 11px 0 5px;
	}
	.activity-list-title-box{
		width: 100%;height: 1.2rem;border-bottom: 1px solid rgba(0,0,0,0.1);display: flex;align-items: center;
	}
	.top-box{
		height: 2.21rem;width: 100%;background: #fff;border-radius: 0 0 10px 10px;overflow: hidden;
	}
	.top-box >>> [class*=van-hairline]::after{border: none;}

	.title{
		width:100%;
		height:26px;
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(0,0,0,1);
		line-height:26px;
		text-align: center;
		margin:10px 0 10px ;
	}
	.box {
		background: #F8F8F8;
		padding-bottom: 50px;
		overflow: hidden; 
	}



</style>

<script>
	import Vue from 'vue'; 
	   import { DropdownMenu, DropdownItem } from 'vant';

Vue.use(DropdownMenu).use(DropdownItem);
	  
	export default {
		name: 'QueryGrade',
		components: { 
			 
		},
		data: function () {
			return {
				active: 1,
				value: 1,
				value2:2,
				switch1: false,
				switch2: false,
				option: [
					{ text: '公开幼儿组 - 公开幼儿甲组' ,value:0},
					{ text: '公开幼儿组 - 公开幼儿乙组' ,value:1},
					{ text: '公开幼儿组 - 公开幼儿丙组' ,value:2},
				]
				 

			}
		},
		filter: {},
		mounted() {
			document.title = '成绩查询';
			 
			// this.fetch()
		},
		destroyed() {
		},
		methods: {
			onConfirm() {
			this.$refs.item.toggle();
			}, 
			dropdownChange(item){
				console.log(item.value)
				this.value=item.value
			}

		}
	}
</script>



// WEBPACK FOOTER //
// QueryGrade.vue?854c653e